export default "__VITE_ASSET__BbWInLKX__"